export const SET_ROWS = 'SET_ROWS'
export const SELECT_GROUP = 'SELECT_GROUP'
export const SELECT_LOCATION = 'SELECT_LOCATION'
export const SET_COLUMN_DEFS = 'SET_COLUMN_DEFS'
export const SET_GROUPS_ROWS = 'SET_GROUPS_ROWS'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB'
export const SET_EXPORT_BUTTON = 'SET_EXPORT_BUTTON'
export const SET_SAVED_FILTERS = 'SET_SAVED_FILTERS'
export const SET_COURSE_MODULE = 'SET_COURSE_MODULE'
export const SET_GROUPS_MODULE = 'SET_GROUPS_MODULE'
export const CLEAR_GROUPS_DATA = 'CLEAR_GROUPS_DATA'
export const SET_SEARCH_BY_DATA = 'SET_SEARCH_BY_DATA'
export const CLEAR_COURSES_DATA = 'CLEAR_COURSES_DATA'
export const SET_GROUPS_UPDATED = 'SET_GROUPS_UPDATED'
export const SET_GROUP_LOCATIONS = 'SET_GROUP_LOCATIONS'
export const SELECT_GROUPS_GROUP = 'SELECT_GROUPS_GROUP'
export const SET_COURSES_UPDATED = 'SET_COURSES_UPDATED'
export const SET_SEARCH_BY_HEADER = 'SET_SEARCH_BY_HEADER'
export const SELECT_CATEGORY = 'SELECT_CATEGORY'
export const SET_SEARCH_BY_CORE = 'SET_SEARCH_BY_CORE'
export const SET_SELECTED_TRAINING = 'SET_SELECTED_TRAINING'
export const SET_GROUPS_INFO_REPORT = 'SET_GROUPS_INFO_REPORT'
export const SELECT_GROUPS_LOCATION = 'SELECT_GROUPS_LOCATION'
export const SET_GROUPS_COLUMN_DEFS = 'SET_GROUPS_COLUMN_DEFS'
export const SET_COURSES_INFO_REPORT = 'SET_COURSES_INFO_REPORT'
export const SET_GROUPS_FOCUSED_CELL = 'SET_GROUPS_FOCUSED_CELL'
export const SET_COURSES_FOCUSED_CELL = 'SET_COURSES_FOCUSED_CELL'
export const CLEAR_GROUPS_FILTER_DATA = 'CLEAR_GROUPS_FILTER_DATA'
export const CLEAR_COURSES_FILTER_DATA = 'CLEAR_COURSES_FILTER_DATA'
export const SET_SELECTED_SAVED_FILTER = 'SET_SELECTED_SAVED_FILTER'
export const RESET_MANAGER_REPORT_DATA = 'RESET_MANAGER_REPORT_DATA'
export const SET_COURSE_SELECTED_ROLES = 'SET_COURSE_SELECTED_ROLES'
export const SET_GROUPS_SELECTED_ROLES = 'SET_GROUPS_SELECTED_ROLES'
export const SET_GROUPS_NEW_FILTER_NAME = 'SET_GROUPS_NEW_FILTER_NAME'
export const SET_GROUP_ROW_SCROLL_INDEX = 'SET_GROUP_ROW_SCROLL_INDEX'
export const SET_GROUPS_LOCATION_GROUPS = 'SET_GROUPS_LOCATION_GROUPS'
export const SET_GROUPS_GROUP_LOCATIONS = 'SET_GROUPS_GROUP_LOCATIONS'
export const SET_EXPORT_TRAINING_BUTTON = 'SET_EXPORT_TRAINING_BUTTON'
export const SET_LOCATION_GROUPS_COURSES = 'SET_LOCATION_GROUPS_COURSES'
export const SET_AREAS = 'SET_AREAS'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_COURSES_NEW_FILTER_NAME = 'SET_COURSES_NEW_FILTER_NAME'
export const SET_COURSE_ROW_SCROLL_INDEX = 'SET_COURSE_ROW_SCROLL_INDEX'
export const SET_GROUP_COLUMN_SCROLL_INDEX = 'SET_GROUP_COLUMN_SCROLL_INDEX'
export const SET_COURSE_COLUMN_SCROLL_INDEX = 'SET_COURSE_COLUMN_SCROLL_INDEX'
export const SET_SHOW_GROUPS_FILTER_OVERALY = 'SET_SHOW_GROUPS_FILTER_OVERALY'
export const SET_SHOW_COURSES_FILTER_OVERALY = 'SET_SHOW_COURSES_FILTER_OVERALY'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'
export const SET_SELECTED_GROUPS_SAVED_FILTER =
  'SET_SELECTED_GROUPS_SAVED_FILTER'
export const SET_COURSE_MANAGER_COURSE_GROUPS =
  'SET_COURSE_MANAGER_COURSE_GROUPS'
export const SET_GROUPS_LOCATION_GROUPS_COURSES =
  'SET_GROUPS_LOCATION_GROUPS_COURSES'
export const SELECT_COURSE_MANAGER_GROUP_LOCATION_GROUPS =
  'SELECT_COURSE_MANAGER_GROUP_LOCATION_GROUPS'
export const SET_SELECTED_GROUPS_LOCATION_GROUPS_COURSES =
  'SET_SELECTED_GROUPS_LOCATION_GROUPS_COURSES'
export const SET_ROLES = 'SET_ROLES'
export const SET_SHOW_EXTERNAL_REPORTS_FILTER_OVERALY =
  'SET_SHOW_EXTERNAL_REPORTS_FILTER_OVERALY'
export const CLEAR_EXTERNAL_REPORTS_DATA = 'CLEAR_EXTERNAL_REPORTS_DATA'
export const CLEAR_EXTERNAL_REPORTS_FILTER_DATA =
  'CLEAR_EXTERNAL_REPORTS_FILTER_DATA'

export const SET_EXTERNAL_REPORTS_MODULE = 'SET_EXTERNAL_REPORTS_MODULE'

export const SET_EXTERNAL_REPORTS_INFO_REPORT =
  'SET_EXTERNAL_REPORTS_INFO_REPORT'

export const SET_SELECTED_EXTERNAL_REPORTS_SAVED_FILTER =
  'SET_SELECTED_EXTERNAL_REPORTS_SAVED_FILTER'
export const SET_EXTERNAL_REPORTS_ROWS = 'SET_EXTERNAL_REPORTS_ROWS'
export const SET_EXTERNAL_REPORTS_FOCUSED_CELL =
  'SET_EXTERNAL_REPORTS_FOCUSED_CELL'
export const SELECT_EXTERNAL_REPORTS_LOCATION =
  'SELECT_EXTERNAL_REPORTS_LOCATION'
export const SET_EXTERNAL_REPORTS_SELECTED_ROLES =
  'SET_EXTERNAL_REPORTS_SELECTED_ROLES'
export const SELECT_EXTERNAL_REPORTS_GROUP = 'SELECT_EXTERNAL_REPORTS_GROUP'
export const SET_EXTERNAL_REPORTS_UPDATED = 'SET_EXTERNAL_REPORTS_UPDATED'
export const SET_EXTERNAL_REPORTS_COLUMN_DEFS =
  'SET_EXTERNAL_REPORTS_COLUMN_DEFS'
export const SET_EXPORT_EXTERNAL_REPORTS_BUTTON =
  'SET_EXPORT_EXTERNAL_REPORTS_BUTTON'
export const RESET_ROLE = 'RESET_ROLE'
export const SET_EXPORTSET_EXPORT_EXTERNAL_REPORTS_BUTTON_BUTTON =
  'SET_EXPORTSET_EXPORT_EXTERNAL_REPORTS_BUTTON_BUTTON'
export const ADD_TO_BREADCRUMB = 'ADD_TO_BREADCRUMB'
export const ADD_TO_BREADCRUMB_ALL = 'ADD_TO_BREADCRUMB_ALL'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_BREADCRUMB_ALL = 'SET_BREADCRUMB_ALL'
export const SET_MANAGER_ID = 'SET_MANAGER_ID'
export const SELECT_GROUPS = 'SELECT_GROUPS'
export const SET_LOADING = 'SET_LOADING'
export const SELECT_GROUPS_GROUPS = 'SELECT_GROUPS_GROUPS'
export const SELECT_EXTERNAL_REPORTS_GROUPS = 'SELECT_EXTERNAL_REPORTS_GROUPS'
export const RESET_REFETCH_MANAGER_REPORTS_COURSES =
  'RESET_REFETCH_MANAGER_REPORTS_COURSES'
export const REFETCH_MANAGER_REPORTS_COURSES = 'REFETCH_MANAGER_REPORTS_COURSES'
export const SET_PUBLIC_CATALOG_COLUMN_DEFS = 'SET_PUBLIC_CATALOG_COLUMN_DEFS'
export const SET_PUBLIC_CATALOG_ROW_DATA = 'SET_PUBLIC_CATALOG_ROW_DATA'
export const SET_PUBLIC_CATALOG_LOADING = 'SET_PUBLIC_CATALOG_LOADING'
export const SET_PUBLIC_CATALOG_CHARTS_LOADING =
  'SET_PUBLIC_CATALOG_CHARTS_LOADING'
export const SET_PUBLIC_CATALOG_CHARTS = 'SET_PUBLIC_CATALOG_CHARTS'
export const SET_PUBLIC_CATALOG_DATA_FETCHED = 'SET_PUBLIC_CATALOG_DATA_FETCHED'
